import get from 'lodash/get';
import * as AuthHelper from '@Services/Auth/AuthHelper';
import { HEADER_NAME_TOKEN, HEADER_NAME_ORIGIN, SOCKET_ENDPOINTS } from '@Services/RsHeader/constants';
import { encryptRsToken, encryptRsOrigin } from '@Services/RsHeader/encryptRsHeader';

// eslint-disable-next-line import/prefer-default-export
export const generateRsHeader = (destination) => {
  if (!SOCKET_ENDPOINTS.includes(destination)) {
    return undefined;
  }

  const pubKey = get(AuthHelper.getUser(), ['details', 'rs_token']);
  const token = AuthHelper.getAccessToken();

  if (!pubKey) {
    return undefined;
  }

  return {
    [HEADER_NAME_TOKEN]: encryptRsToken(pubKey, token),
    [HEADER_NAME_ORIGIN]: encryptRsOrigin(pubKey),
  };
};
